module.exports = __webpack_public_path__ + "static/media/favicon.20725826.ico";